import {get} from '../libs/ajax.js'

export default {
    // 离线下载-下载列表
    getDownloadList:(data, options)=>{
        return get('/download_center/get_list', data, options);
    },
    // 离线下载-检查下载
    checkDownload:(data, options)=>{
        return get('/download_center/check_download',data, options);
    },
    // 离线下载-下载
    downloadFile:(data, options)=>{
        return get('/download_center/download',data, options);
    },
    //离线下载-获取功能模块列表
    getDownloadModules:(data, options)=>{
        return get('/download_center/get_modules',data, options);
    },

    //离线下载-刷新进度条
    getStatus:(data, options)=>{
        return get('/download_center/get_status',data, options);
    },
    //离线下载-重试
    retry:(data, options)=>{
        return get('/download_center/retry',data, options);
    },



}
